import {
    FETCH_SQUIRREL_NEWS_REQUEST,
    FETCH_SQUIRREL_NEWS_SUCCESS,
    FETCH_SQUIRREL_NEWS_FAILURE,
} from '../constants/squirrelNewsTypes';

const initialState = {
    loading: false,
    squirrelNews: [],
    error: '',
};

const squirrelNewsReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_SQUIRREL_NEWS_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case FETCH_SQUIRREL_NEWS_SUCCESS:
            return {
                loading: false,
                squirrelNews: action.payload,
                error: '',
            };
        case FETCH_SQUIRREL_NEWS_FAILURE:
            return {
                loading: false,
                squirrelNews: [],
                error: action.payload,
            };
        default:
            return state;
    }
};

export default squirrelNewsReducer;
